'use strict';

module.exports = require('../../date-picker/locale/en_US');


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/calendar/locale/en_US.js
 ** module id = 830
 ** module chunks = 0
 **/